import React from 'react'
import { UseFormReturn } from 'react-hook-form';
import { MasterMedicine } from '../../../../apis/master-medicines/types';
import HtmlEditor from '../../../FormEditors/HtmlEditor';

interface MasterMedicineEditorProps {
  form: UseFormReturn<MasterMedicine>;
}

const MasterMedicineDescriptionEditor = ({ form }: MasterMedicineEditorProps) => {
  return <HtmlEditor control={form.control} label="Description" name="description" />;
};

export default MasterMedicineDescriptionEditor;
